import { jsx as e, jsxs as h } from "react/jsx-runtime";
import { useRef as s, useLayoutEffect as u } from "react";
import { ArrowIonicRightIcon as d } from "../../icons/arrow-ionic-right-icon.mjs";
import { Loader as w } from "../loader/index.mjs";
import { BreadcrumbItem as m } from "./breadcrumbs-item.mjs";
import { twMerge as p } from "tailwind-merge";
const y = ({
  data: l,
  isFetching: c,
  classnameBreadcrumbsItem: a,
  CustomBreadcrumbLinkItem: f
}) => {
  const t = s(null), o = s(null);
  return u(() => {
    t.current && o.current && t.current.scrollTo(o.current.offsetLeft, 0);
  }, [c]), /* @__PURE__ */ e(
    "ul",
    {
      ref: t,
      className: `
        md:overflow:hidden hide-scrollbar
        flex min-h-[42px] w-full flex-nowrap items-center gap-3 gap-y-0
        overflow-scroll whitespace-nowrap
        md:flex-wrap md:truncate 
        lg:flex-nowrap
      `,
      children: l.map((r, i) => {
        const n = i === l.length - 1;
        return /* @__PURE__ */ h(
          "li",
          {
            className: "flex flex-nowrap items-center gap-3 md:truncate",
            ref: n ? o : void 0,
            children: [
              i !== 0 && /* @__PURE__ */ e(d, { height: "14", width: "10", fill: "rgb(var(--text-tertiary))" }),
              !r.isStatic && c ? /* @__PURE__ */ e(w, { small: !0, type: "dark" }) : r.href ? /* @__PURE__ */ e(
                m,
                {
                  isLast: n,
                  className: p(a),
                  isLink: !0,
                  onClick: r.onClick,
                  children: f ? /* @__PURE__ */ e(f, { href: r.href, children: r.caption }) : /* @__PURE__ */ e("a", { href: r.href, rel: "noreferrer", className: "outline-hidden", children: r.caption })
                }
              ) : /* @__PURE__ */ e(
                m,
                {
                  onClick: r.onClick,
                  className: p(a),
                  isLast: n,
                  children: r.caption
                }
              )
            ]
          },
          i
        );
      })
    }
  );
};
export {
  y as Breadcrumbs
};
